<template>
  <div>
    <a-space>
      <a-button @click="getData" type="primary">{{ $t('button.refresh') }}</a-button>
    </a-space>
    <a-divider/>
    <a-steps v-model="current" size="small" type="navigation" :style="stepStyle">
      <a-step v-for="item in navigationData"
              :title="item.name"
              :key="item.step"
              :status="current >item.step? 'finish' : current === item.step? 'process' : 'wait'"/>
    </a-steps>
  </div>
</template>

<script>
import { findOne } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'

export default {
  name: 'ConfigNavigation',
  data() {
    return {
      loading: false,
      navigationData: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.72),// 表格竖向滚动条
      current:1,
      stepStyle: {
        marginBottom: '60px',
        boxShadow: '0px -1px 0 0 #e8e8e8 inset',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      findOne('fieldFactory', { no: 'CONFIG_NAVIGATION' }).then(res => {
        if (res.success) {
          this.navigationData=[]
          this.$nextTick(() => {
            res.result.dictionaries.forEach(item=>{
              const stepData=JSON.parse(item.value)
              Object.assign(item,stepData)
              this.navigationData.push(item)
            })
            this.navigationData.sort((a,b)=>a.ordinal-b.ordinal)
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }

}
</script>

<style scoped>
</style>